export default __webpack_public_path__ + "static/logo-6ab758a8d0578a1ae1d3672b56486a68.png";